import classnames from "classnames";
import { useEffect } from "react";
import { Link, LinkProps, useMatch, useResolvedPath } from "react-router-dom";

interface Iprops extends LinkProps {
    /**
     * 主题颜色
     */
    themecolor?: string
    /**
     * 回调函数
     */
    active?: any
}
export default function CustomLink(props: Iprops) {
    /**
     * 定义导航的目标路径。
     */
    const to = props.to;
    /**
     * 显示在链接内的子节点内容
     */
    const children = props.children;
    /**
     * 使用 `useResolvedPath` 将 `to` 属性解析为绝对路径，便于路由匹配。
     */
    const resolved = useResolvedPath(to);
    /**
     * 使用 `useMatch` 检查当前路由是否与目标路径匹配。
     */
    const match = useMatch({ path: `${resolved?.pathname}/*` });
    /**
     * 如果传递了 `active` 回调函数，则在路由匹配发生变化时调用。
     */
    useEffect(() => {
        if (props.active) {
            props.active(!!match)
        }
    }, [match])

    return (
        <Link to={to} className={`${classnames({ 'active': !!match })} ${props.className}`} style={{ color: !!match && props.themecolor ? props.themecolor : null }}>
            {children}
        </Link>
    )
}